import { Fragment } from "react/jsx-runtime";
import { P } from "../../../../../AbstractElements";
import { Href, RecentChats } from "../../../../../Constants/Constants";
import { Link } from "react-router-dom";
import ChatUserProfile from "./ChatUserProfile";

export const ChatTabPane = () => {
  return (
    <Fragment>
      <div className="common-space">
        <P>{RecentChats}</P>
        <div className="header-top">
          <Link className="badge-light-primary f-w-500 btn" to={Href}>
            <i className="fa fa-plus" />
          </Link>
        </div>
      </div>
      <ChatUserProfile />
    </Fragment>
  );
};
